import BaseTabButtons from "@PegasusCore/pegasus-one-tab-buttons/src/script";

class TabButtons extends BaseTabButtons {
    constructor() {
        super();
        this.timer = null;
        this.isTimerActive = false;
        this.timerInterval = 6000;
        this.shouldRealign = false;
        this.initialPosition = null;
    }

    init() {
        super.init();
        this.initialPosition = this.$el.getBoundingClientRect().top + window.pageYOffset;
    }

    initTabButtons(firstTargetID, autoSwitch = false, realignContent = false) {
        super.initTabButtons(firstTargetID);
        this.isTimerActive = autoSwitch;
        this.shouldRealign = realignContent;
        
        if (this.isTimerActive) {
            this.startTimer();
        }
    }

    startTimer() {
        this.stopTimer();
        this.timer = setInterval(() => {
            this.autoSwitchTab();
        }, this.timerInterval);
    }

    stopTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    autoSwitchTab() {
        const currentIndex = this.tabButtons.indexOf(this.activeTab);
        const nextIndex = (currentIndex + 1) % this.tabButtons.length;
        const nextTab = this.tabButtons[nextIndex];
        
        this.showTab(nextTab);
    }

    scrollToElement() {
        const offset = 70;
        const scrollPosition = this.initialPosition - offset;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    }

    showTab(targetID) {
        super.showTab(targetID);
        
        if (this.isTimerActive) {
            this.stopTimer();
            this.startTimer();
        }
        
        if (this.shouldRealign) {
            setTimeout(() => {
                this.scrollToElement();
            }, 100);
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("tabButtons", () => new TabButtons());
});
